export default __webpack_public_path__ + "static/media/oneLayer.8643baa8.png";